<template>
  <div class="container mt-0">
    <div class="row">
      <div class="col-12">

        <!-- page title -->
        <h2 class="mb-4 h3">{{ title }}</h2>

        <results :hasPagination="true" :type="null" :limit="10"></results>
      </div> <!-- col-12 -->
    </div> <!-- row -->
  </div> <!-- container -->      
</template>

<script>
import Results from '../components/Results.vue'

export default {
  components: {
    results: Results
  },
  data () {
    return {
      language: 'en',
      title: this.$t('search_title')
    }
  }
}
</script>
